import { useCallback } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { IntakePanel } from "@/components/intake/IntakePanel";
import { summarize } from "@/components/intake/intakeModel";

export const StepCustomers = ({ userId, instanceId, data, patch, patchSpec, busy, onBack, onNext }) => {
  const items = data.intakeItems || [];
  const staged = new Set(items.map((i) => (i.companyName || "").toLowerCase()));
  const seeds = (data.analysis?.detectedCustomers || []).filter((n) => !staged.has(n.toLowerCase()));

  const onStage = useCallback((next) => {
    patch((prev) => {
      const customers = next.filter((i) => i.relationship === "customer" && i.companyName).map((i) => i.companyName);
      const best = [...new Set([...(prev.bestCustomers || []), ...customers])].slice(0, 10);
      return { intakeItems: next, bestCustomers: best };
    });
    patchSpec((prev) => ({ lookalikeSeeds: [...new Set([...(prev.lookalikeSeeds || []), ...next.filter((i) => i.relationship === "customer").map((i) => i.companyName)])].slice(0, 10) }));
  }, [patch, patchSpec]);

  const s = summarize(items);

  return (
    <div className="space-y-5" data-testid="onboarding-step-customers">
      <div>
        <h2 className="text-2xl text-white font-light">Who do you already work with — and who do you wish you did?</h2>
        <p className="text-gray-400 mt-1 text-sm">Current customers teach me what a win looks like and what to farm. Wishlist accounts jump the queue in the hunt. Spreadsheets, CRM exports, PDFs, screenshots or a few lines of notes all work — or skip for now.</p>
      </div>

      <IntakePanel userId={userId} instanceId={instanceId} mode="stage" initialItems={items} seedCustomers={seeds} onStage={onStage} />

      <div className="flex justify-between items-center pt-2">
        <Button variant="ghost" onClick={onBack} className="text-gray-400 hover:text-white" data-testid="onboarding-back-btn"><ArrowLeft className="h-4 w-4 mr-2" /> Back</Button>
        <div className="flex items-center gap-3">
          {s.total > 0 && <span className="text-xs text-gray-500" data-testid="customers-staged-count">{s.customer} customers · {s.wishlist} wishlist staged</span>}
          <Button onClick={onNext} disabled={busy} className="bg-ism-teal hover:bg-ism-teal/90 text-black font-medium rounded-xl px-6" data-testid="onboarding-customers-next">
            {s.total ? "Continue" : "Skip for now"} <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
};
